import {
  browserName,
  deviceDetect,
  deviceType,
  fullBrowserVersion,
  isChrome,
  isDesktop,
  isMobileOnly,
  isTablet,
  mobileModel,
  osName,
  osVersion
} from 'react-device-detect';

import { deviceConstants } from '@nw/shared/config';

export const isDeviceRealDesktop = () => isDesktop;

export const getDeviceType = () => deviceType;

export const getDeviceDetails = (userAgent) => deviceDetect(userAgent);

export const checkIsChromeBrowser = (): boolean => isChrome;

export const isRealMobileOnly = (): boolean => isMobileOnly;

export const isRealTabletDevice = (): boolean => isTablet;

export const getDeviceBrowserName = (): string => browserName;

export const getDeviceFullBrowserVersion = (): string => fullBrowserVersion;

export const getDeviceOSName = (): string => osName;

export const getDeviceOSVersion = (): string => osVersion;

export const getDeviceModel = (): string => mobileModel;

export const getDeviceTypeAtAnalyticsTracking = (): string => {
  const { mobile, tablet, desktop, other } = deviceConstants;
  if (isRealMobileOnly()) {
    return mobile;
  } else if (isRealTabletDevice()) {
    return tablet;
  } else if (isDeviceRealDesktop()) {
    return desktop;
  }
  return other;
};

const devicePropertyMappings = {
  deviceType: getDeviceTypeAtAnalyticsTracking,
  deviceBrowserName: () => getDeviceBrowserName(),
  deviceBrowserVersion: getDeviceFullBrowserVersion,
  deviceOSName: getDeviceOSName,
  deviceOSVersion: getDeviceOSVersion,
  deviceModel: getDeviceModel
};

export const getDeviceDetailsObjectBasedOnKeys = (keys) => {
  const deviceDetails = {};
  for (const key in keys) {
    if (keys[key] && devicePropertyMappings[key]) {
      deviceDetails[keys[key]] = devicePropertyMappings[key]();
    }
  }
  return deviceDetails;
};
